import { MdsEdit } from "@sinch/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { GridActionsCellItem } from "@sinch/components/GridActionsCellItem/GridActionsCellItem";
import { MdsIcon } from "@sinch/components/index";

export const EditActionItem = (props: { href: string }) => {
  const { t } = useTranslation();
  return (
    <GridActionsCellItem
      key="edit"
      color="info"
      component="a"
      {...{ href: props.href }}
      icon={<MdsIcon icon={MdsEdit} />}
      label={t("edit")}
    />
  );
};
